export const LEDGER_TAB = {
  job: "job",
  jobseeker: "jobseeker",
  fee: "fee",
} as const;

export type TLedgerTabValue = (typeof LEDGER_TAB)[keyof typeof LEDGER_TAB];

export const LEDGER_TAB_OPTIONS: { label: string; value: TLedgerTabValue }[] = [
  { label: "求人管理簿", value: LEDGER_TAB.job },
  { label: "求職管理簿", value: LEDGER_TAB.jobseeker },
  { label: "手数料管理簿", value: LEDGER_TAB.fee },
];
